// Built-in picture elements (transparent PNGs served by the backend at /api/elements/<id>.png;
// drawn by backend/scripts/elements/make_element_art.py, printed by the server like an uploaded photo).
import { PAGE_HEIGHT, PAGE_WIDTH } from '../../utils/invitationStyle';

export const ELEMENT_ART_PREFIX = '/api/elements/';

// [id, name, keywords, width %, natural width, natural height]
const OBJECTS = [
  ['wine-bottle', 'Wine bottle', 'wine bottle yayin kiddush drink', 10, 160, 480],
  ['kiddush-cup', 'Kiddush cup', 'kiddush cup becher wine goblet silver gold', 16, 240, 340],
  ['tefillin', 'Tefillin', 'tefillin bar mitzvah bar mitzveh shin straps', 26, 366, 312],
  ['onion', 'Onion', 'onion tzibele zucher vachnacht food', 16, 260, 304],
  ['sugar', 'Sugar cubes', 'sugar cubes tzucker sweet zucher', 18, 300, 270],
  ['challah', 'Challah', 'challah bread shabbos kiddush braided', 30, 400, 200],
  ['candlesticks', 'Candlesticks', 'candles candlesticks shabbos licht', 20, 300, 404],
  ['crown', 'Crown', 'crown keser kesser torah', 20, 300, 250],
];

const ORNAMENTS = [
  ['corner-flourish', 'Corner flourish', 'corner flourish ornament swirl gold design frame', 24, 304, 304],
  ['swirl-divider', 'Swirl divider', 'divider swirl ornament line gold design', 46, 600, 120],
  ['laurel-wreath', 'Laurel wreath', 'laurel wreath leaves circle gold design', 34, 400, 400],
  ['floral-spray', 'Floral spray', 'flowers floral branch blossom pink design', 30, 380, 280],
  ['rosette', 'Rosette', 'rosette medallion mandala sun gold design', 22, 300, 300],
  ['oval-frame', 'Oval frame', 'oval frame cartouche border gold design', 46, 400, 520],
];

const toArt = ([id, name, keywords, w, nw, nh]) => ({
  id,
  name,
  keywords,
  src: `${ELEMENT_ART_PREFIX}${id}.png`,
  // height is % of page height: keep the picture's own proportions on the 8.5 x 11 page
  items: [{ type: 'image', src: `${ELEMENT_ART_PREFIX}${id}.png`, w, h: Math.round(((w * PAGE_WIDTH) / PAGE_HEIGHT) * (nh / nw) * 10) / 10, fit: 'contain', radius: 0 }],
});

// No longer offered in the Elements picker, but the PNG is still served so invitations and
// templates that already placed it keep rendering, printing and showing their layer name.
const RETIRED = [
  ['magen-david', 'Star of David', '', 18, 300, 300],
];

export const ART_OBJECTS = OBJECTS.map(toArt);
export const ART_ORNAMENTS = ORNAMENTS.map(toArt);
export const ART_RETIRED = RETIRED.map(toArt);
